import React from "react";

export const FilterPills = ({ options, value, onChange, testidPrefix }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={testidPrefix ? `${testidPrefix}-group` : undefined}>
    {options.map((o) => (
      <button
        key={o.key}
        data-testid={testidPrefix ? `${testidPrefix}-${o.key}` : undefined}
        onClick={() => onChange(o.key)}
        className={`rounded-full px-3 py-1.5 text-xs font-medium border transition-colors ${
          value === o.key
            ? "bg-[#1E3F33] text-white border-[#1E3F33]"
            : "bg-white text-[#1E3F33] border-[#1E3F33]/15 hover:border-[#1E3F33]/40"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
